import RecruitmentSite from './components/RecruitmentSite'

function App() {
  return <RecruitmentSite />
}

export default App
